const MAP = {
  // デフォルト住所：日比谷公園
  initialPosition: {
    center: [139.757109, 35.675869],
    zoom: 15,
    pitch: 0,
    bearing: 0,
  },

  // デフォルトの地図スタイル名
  defaultStyleName: 'default',
  defaultStyleLabel: 'デフォルト',
  // デフォルトの傾斜角
  defaultPitch: 0,
  // 3Dモード時の傾斜角
  pitchFor3dMode: 60,
  // デフォルトの方位角
  defaultBearing: 0,
  // 地図移動時のアニメーション時間（ミリ秒）
  animationDurationMs: 500,
  // 長押しと判定するまでの時間（ミリ秒）
  longPressTimerMs: 700,
  // 地図操作中フラグをリセットするまでの時間（ミリ秒）
  movingResetDelayMs: 100,
  // 画面ロード時のローディング進捗
  loadingProgressComplete: 100,
  // idle検知後、100％表示を一瞬見せてから非表示にするための遅延(ms)
  loadingHideDelayMs: 100,

  // URL同期のデバウンスタイム（ミリ秒）
  urlSyncDebounceMs: 1000,
  // ポップアップのオフセット
  popupOffset: 25,
  // 地図のデフォルトモード
  defaultMapMode: 'normal',

  styles: {
    // 境界線マップ
    boundary: 'boundary',
    boundaryLabel: '境界線マップ',
    // 通り名マップ
    street: 'street',
    streetLabel: '通り名マップ',
    // 地形図
    terrain: 'terrain',
    terrainLabel: '地形図',
    // ひらがなマップ
    kana: 'kana',
    kanaLabel: 'ひらがなマップ',
  },
  // 国盗り制御のパラメータ
  kntrParamKey: 'from',
  kntrParamValue: 'kntr',

  // 地図移動・ズーム変更の検知閾値
  thresholds: {
    // 緯度経度の変化がこれ以上なら「移動した」と判定
    position: 0.0001,
    // ズームレベルの変化がこれ以上なら「変化した」と判定
    zoom: 0.01
  },

  // 最適縮尺の調整用の定数
  zoomAdjust: {
    // 推定値がピッタリすぎて一部はみ出すリスクを回避するための値、現状0で良い
    safetyMargin: 0,
    // マーカーが画面端ぎりぎりにならないようにする余白（ピクセル）
    padding: 32,
    // 地図の最小・最大ズームレベル
    adjustMinZoom: 4,
    adjustMaxZoom: 18,
  },
  // スケールバーの計算で使用するtileSize（map.transform.tileSizeに合わせる）
  tileSize: 512,

  // 遠距離検索と近距離検索の境界（メートル）
  distanceThresholdMeters: 10000,

  zoomLevel: {
    minZoom: 5,
    rasterMinZoom: 6,
    prefZoomLevel: 8,
    cityZoomLevel: 12,
    airportZoomLevel: 13,
    stationZoomLevel: 14,
    defaultZoomLevel: 15,
    shareUrlZoomLevel: 17,
    maxZoom: 19
  },

  // 座標表示の小数点以下桁数のデフォルト値
  defaultCoordPrecision: 6,
  defaultZoomPrecision: 2,

  // 大まかな地図の範囲
  validRange: {
    minLat: 20.0,
    maxLat: 50.0,
    minLng: 120.0,
    maxLng: 160.0,
  },

  // 標高情報設定
  elev: {
    // 標高データが取得できない場合の値
    unknownValue: -9999,
    // 文字列表現
    unknownString: '-9999',
    // ユーザー向け表示ラベル
    unknownLabel: '不明'
  },

  fullScreen: {
    // フルスクリーンにする対象のセレクタ
    selectorFullScreen: '.map-content',
    // 要素が見つからない場合のメッセージ
    elementNotFoundMessage: '要素が見つかりません'
  },

  mapcode: {
    messages: {
      empty: 'マップコードが空です',
      parseError: 'マップコードの解析に失敗しました',
      conversionError: 'マップコードを座標に変換できませんでした'
    }
  }
};


export default MAP;
